import { AutoCompleteOption } from '../../components/Inputs/Select/AutoComplete/AutoComplete.model'
import { DateTrustCode } from '../common/types'

export const PEOPLE_STORE_ID = 'people'

export type Person = {
  readonly id: number
  readonly email: string
  readonly emailValidationStatus: EmailValidationStatus
  readonly firstName: string
  readonly lastName: string
  readonly gender: string
  readonly bornOn: string
  readonly bornOnTrustCode: DateTrustCode | ''
  readonly diedOn: string
  readonly diedOnTrustCode: DateTrustCode | ''
  readonly roles: Position[]
  readonly educations: Education[]
  readonly blurb?: string
  readonly description?: string
  readonly linkedinUrl?: string
}

export type Position = PositionUXParams & {
  readonly id: number
  readonly personId: number
  readonly organizationId: number
  readonly organization: AutoCompleteOption | null
  readonly title: string
  readonly description: string
  readonly startedOn: string
  readonly startedOnTrustCode: DateTrustCode
  readonly endedOn: string
  readonly endedOnTrustCode: DateTrustCode
  readonly isCurrent: boolean
  readonly person?: Person
}

type PositionUXParams = Partial<{
  toDelete: boolean
}>

export type Education = EducationUXParams & {
  readonly id: number
  readonly personId: number
  readonly organizationId: number
  readonly organization: AutoCompleteOption | null
  readonly degreeType: string
  readonly degreeSubject: string
  readonly grade: string
  readonly startedOn: Date | string
  readonly startedOnTrustCode: DateTrustCode
  readonly endedOn: Date | string
  readonly endedOnTrustCode: DateTrustCode
}

type EducationUXParams = Partial<{
  toDelete: boolean
}>

export enum Gender {
  male = 'male',
  female = 'female',
  other = 'other',
}

export type IdIndexedPeople = {
  readonly [personId: number]: Person
}

export type PersonData = Partial<Person>

export type PeopleState = {
  readonly isFetching: boolean
  readonly items: IdIndexedPeople
}

export enum EmailValidationStatus {
  validated = 'validated',
  unvalidated = 'unvalidated',
  discarded = 'discarded',
}

export function newPerson() {
  return {
    email: '',
    firstName: '',
    lastName: '',
    emailValidationStatus: EmailValidationStatus.unvalidated,
    gender: undefined,
    bornOn: undefined,
    bornOnTrustCode: DateTrustCode.invalid,
    diedOn: undefined,
    diedOnTrustCode: DateTrustCode.invalid,
    roles: [],
    educations: [],
  }
}

let newPositionId = 0

export function newRole(personId?: number) {
  newPositionId--
  return {
    id: newPositionId,
    personId,
    organizationId: undefined,
    title: '',
    description: '',
    startedOn: '',
    startedOnTrustCode: DateTrustCode.invalid,
    endedOn: '',
    endedOnTrustCode: DateTrustCode.invalid,
    isCurrent: true,
    toDelete: false,
  }
}

let newEducationId = 0

export function newEducation(personId?: number) {
  newEducationId--
  return {
    id: newEducationId,
    personId,
    organizationId: undefined,
    degreeType: '',
    degreeSubject: '',
    grade: '',
    startedOn: '',
    startedOnTrustCode: DateTrustCode.invalid,
    endedOn: '',
    endedOnTrustCode: DateTrustCode.invalid,
    toDelete: false,
  }
}
